module.exports = __webpack_public_path__ + "img/d16.501f16b9.png";